export * from "./api";
export * from "./routes";
export * from "./sidebar";

// Distinct badge background per role name (falls back to grey for unknowns).
export const roleColors: Record<string, string> = {
  SuperAdmin: "#6a1b9a",
  MasterAdmin: "#1565c0",
  SuperAgent: "#00838f",
  MasterAgent: "#2e7d32",
  Agent: "#558b2f",
  SubAgent: "#9e9d24",
  Player: "#ef6c00",
  CMSAdmin: "#ad1457",
  GameAdmin: "#4527a0",
  ReportAdmin: "#00695c",
  RiskMangeAdmin: "#c62828",
  CRMAdmin: "#5d4037",
};

export const getRoleColor = (name?: string): string => (name && roleColors[name]) || "#757575";

// `label` holds an i18n key; resolve it with `t(option.label)` at render time.
export const statusOptions = [
  {
    value: true,
    label: "common.active",
  },
  {
    value: false,
    label: "common.inactive",
  },
];

// Static timezone list. Label shows the GMT offset only,
// value is the offset (stored as a number in the DB).
export const timezoneOptions = [
  { label: "GMT-12", value: "-12" },
  { label: "GMT-11", value: "-11" },
  { label: "GMT-10", value: "-10" },
  { label: "GMT-9", value: "-9" },
  { label: "GMT-8", value: "-8" },
  { label: "GMT-7", value: "-7" },
  { label: "GMT-6", value: "-6" },
  { label: "GMT-5", value: "-5" },
  { label: "GMT-4", value: "-4" },
  { label: "GMT-3", value: "-3" },
  { label: "GMT-2", value: "-2" },
  { label: "GMT-1", value: "-1" },
  { label: "GMT+0", value: "0" },
  { label: "GMT+1", value: "1" },
  { label: "GMT+2", value: "2" },
  { label: "GMT+3", value: "3" },
  { label: "GMT+4", value: "4" },
  { label: "GMT+5", value: "5" },
  { label: "GMT+6", value: "6" },
  { label: "GMT+7", value: "7" },
  { label: "GMT+8", value: "8" },
  { label: "GMT+9", value: "9" },
  { label: "GMT+10", value: "10" },
  { label: "GMT+11", value: "11" },
  { label: "GMT+12", value: "12" },
  { label: "GMT+13", value: "13" },
  { label: "GMT+14", value: "14" },
];

export const tags = [
  // General Casino
  "Casino Games",
  "Gambling Tips",
  "Casino Bonuses",
  "Online Casinos",
  "Land-Based Casinos",
  "Casino News",
  "Gambling Strategies",
  "High Rollers",
  "Responsible Gambling",
  "Casino Reviews",

  // Game-Specific
  "Slots",
  "Blackjack",
  "Poker",
  "Roulette",
  "Baccarat",
  "Craps",
  "Video Poker",
  "Live Dealer Games",
  "Progressive Jackpots",
  "Table Games",
  "Sic Bo",
  "Pai Gow",
  "Keno",
  "Bingo",

  // Online Gambling
  "Best Online Casinos",
  "Mobile Gambling",
  "No Deposit Bonuses",
  "Free Spins",
  "RNG",
  "Casino Software",
  "Online Casino Security",

  // **Crypto & Blockchain Gambling**
  "Bitcoin Casinos",
  "Ethereum Gambling",
  "Crypto Slots",
  "NFT Casinos",
  "Provably Fair Games",
  "Decentralized Casinos",
  "Altcoin Betting",
  "Crypto Bonuses",
  "Blockchain Poker",
  "Anonymous Gambling",
  "Web3 Casinos",
  "Metaverse Gambling",

  // **Sportsbook & Betting Types**
  "Sports Betting",
  "Esports Betting",
  "Horse Racing",
  "Football Betting",
  "Basketball Betting",
  "Tennis Betting",
  "Baseball Betting",
  "Boxing Betting",
  "Golf Betting",
  "MMA Betting",
  "CS:GO Betting",
  "Dota 2 Betting",
  "League of Legends Betting",
  "Live Betting",
  "Parlay Bets",
  "Over/Under Bets",
  "Moneyline Bets",
  "Prop Bets",
  "Futures Betting",
  "Exchange Betting",
  "Asian Handicap",

  // Poker
  "Texas Hold’em",
  "Omaha Poker",
  "Poker Tournaments",
  "WSOP",
  "Bluffing Strategies",
  "Poker Hands",

  // Casino Lifestyle
  "Casino Resorts",
  "VIP Programs",
  "Casino Comps",
  "Celebrity Gamblers",
  "Casino Movies",
  "Gambling Humor",

  // Legal & Regulatory
  "Gambling Laws",
  "Licensing Authorities",
  "Legal Online Gambling",
  "Casino Taxes",
  "Gambling Addiction Help",

  // Tech & Innovations
  "VR Casinos",
  "AI in Gambling",
  "Live Streaming Casinos",
];

export const tags2 = ["Crypto", "Sport", "Casino", "How to Guides", "SkyStake News", "Other News"];

export const topics = [
  "Crypto",
  "Bets",
  "Casino",
  "Winning",
  "NFL Survival Pool",
  "Prize Catch",
  "Sponsorship",
];
